/*eslint-disable*/ export const messages = {
    Apply: "Appliquer",
    Clear: "Clear",
    "Date picker open, choose a date": "Sélecteur de dates ouvert, choisir une date",
    "Date range picker open, select a date range":
        "Sélecteur de plage de dates ouvert, sélectionner une plage de dates",
    "End Date": "Date de fin",
    "Please enter a date ({format})": ["Veuillez saisir une date (", ["format"], ")"],
    "Please select a date after {minDate}": ["Veuillez sélectionner une date après ", ["minDate"]],
    "Please select a date before {maxDate}": ["Veuillez sélectionner une date avant ", ["maxDate"]],
    "Show next month": "Afficher le mois suivant",
    "Show previous month": "Afficher le mois précédent",
    "Start Date": "Date de début",
    "The selected date is disabled": "La date sélectionnée est désactivée",
    "The selected date is unavailable. Please select another.":
        "La date sélectionnée n’est pas disponible. Veuillez en sélectionner une autre.",
    Today: "Today",
    "Today, {dateStr}": ["Aujourd’hui, ", ["dateStr"]],
    "date picker": "sélecteur de dates",
    "start date selected": "date de début sélectionnée",
    to: "to",
    "{dateStr}, select end date": [["dateStr"], ", sélectionner la date de fin"],
    "{dateStr}, select start date": [["dateStr"], ", sélectionner la date de début"],
    "{startDate} to {endDate}, choose apply to confirm, or cancel": [
        ["startDate"],
        " au ",
        ["endDate"],
        ", choisir appliquer pour confirmer, ou annuler",
    ],
};
